import { useTranslation } from 'react-i18next';
import styles from './configurator-menu.module.scss';
import Link from 'next/link';
import { Trans } from 'react-i18next';
import logoImage from '../../../../public/bb_logo.svg';
import Image from 'next/image';
import * as routing from '@routing';

const CardContainer = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.cardContainer}>
      <div className={styles.card}>
        <Image
          src={logoImage}
          role="presentation"
          alt=""
          priority={true}
          className={styles.logoImage}
        />
      </div>
      <div className={styles.linkContainer}>
        <Trans t={t} i18nKey="gift_card_configurator.plastic_card_link">
          <Link href={routing.products({ taxon: 'darkove-karty' })}></Link>
        </Trans>
      </div>
    </div>
  );
};

interface ConfiguratorMenuProps {
  readonly isPlasticCardDisplayed?: boolean;
}

const ConfiguratorMenu: React.FC<
  React.PropsWithChildren<ConfiguratorMenuProps>
> = ({ children, isPlasticCardDisplayed }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('gift_card_configurator.title')}</div>
      {isPlasticCardDisplayed && <CardContainer />}
      <ul className={styles.menu}>{children}</ul>
    </div>
  );
};

export default ConfiguratorMenu;
